import {
    post,
    get,
    del,
    put
} from './http'
export default {
    // 登录
    login(param, config) {
        return post('/user/login/', param, config)
    },
    //登出
    logout(params) {
        return post('/user/logout', params)
    },
    // 修改密码
    changePass(params) {
        return post('/auth/resetPWD', params)
    },
    gethome() {
        return get('/home_page/home_page_data')
    },
    getuser(params) {
        return get('/home_page/home_user_data',params)
    },
    // 获取二级图谱
    getCenterLinks(params){
        return get('/home_page/home_center_links',params)
    },
    //上传BOM
    upload_sbom(){
        return post('/sbom/upload_sbom', params) 
    },
    get_sbom(params) {
        return get('/sbom/get_sbom',params)
    },
    get_sbom_list(params){
        return get('/sbom/get_sbom_list',params)
    },
    //删除 sbom
    delete_sbom(params){
        return post('/sbom/delete_sbom', params)
    },
    //组件列表添加关注
    add_Focuse(params){
        return post('/sbom/like_sbom_package', params)
    },
    //组件列表取消关注
    canseFocus(params){
        return post('/sbom/unlike_sbom_package', params)
    },
    //关注Sbom
    add_Sbom(params){
        return post('/sbom/like_sbom', params)
    },
    //取消关注SBOM
    cance_Sbom(params){
        return post('/sbom/unlike_sbom', params)
    },
    //编辑sbom
    get_sbom_info(params){
        return get('/sbom/get_sbom_info', params)
    },
    //提交sbom
    edit_sbom(params){
        return post('/sbom/edit_sbom', params)
    },
    //获取组件
    get_sbom_package(params){
        return get('/sbom/get_sbom_package', params)
    },
    //删除组件
    delete_package(params){
        return post('/sbom/delete_package', params)
    },
    //上传
    addfiles(params){
        return post('/sbom/upload_sbom', params)
    },
}